"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 1 };
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const TyreFilter_vue_1 = __importDefault(require("../../components/ProductSearch/TyreFilter.vue"));
const forms_1 = require("../../components/ProductSearch/forms");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const i18n_1 = require("../../common/i18n");
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductAccessories',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const currentType = (0, vue_3.ref)("accessories");
        const mainCategorySelectedItem = (0, vue_3.ref)("720");
        const mainCategoryItems = (0, vue_3.ref)([
            new DropdownInputItem_1.default("740", `${(0, i18n_1.trans)("windshieldWiper", "Windshield wiper", "accessories_filter")}`),
            new DropdownInputItem_1.default("720", `${(0, i18n_1.trans)("snowChains", "Snow chains", "accessories_filter")}`),
            new DropdownInputItem_1.default("730", `${(0, i18n_1.trans)("hubcap", "Hub cap", "accessories_filter")}`),
            new DropdownInputItem_1.default("750", `${(0, i18n_1.trans)("carCareProduct", "Car care products", "accessories_filter")}`),
            new DropdownInputItem_1.default("755", `${(0, i18n_1.trans)("otherAccessories", "Other accessories", "accessories_filter")}`),
        ]);
        const filterValues = (0, vue_3.computed)(() => productFilterStore.productFilters);
        const initForm = (mainCategory) => {
            let type = (0, forms_1.calculateTypeFromAxCategory)(mainCategory);
            currentType.value = type;
            let _form = { axCategory: [mainCategory] };
            if ("accessories" == type) {
                _form = Object.assign(forms_1.accessoriesProductSearchForm, _form);
            }
            return _form;
        };
        let form = (0, vue_3.ref)(Object.assign({}));
        form.value = Object.assign(form.value, initForm(mainCategorySelectedItem.value));
        const initQueryParams = (0, tyre_search_1.getQueryParams)(form.value, route);
        for (const key in initQueryParams) {
            if (initQueryParams.hasOwnProperty(key)) {
                if (key === "axCategories") {
                    mainCategorySelectedItem.value = initQueryParams[key][0];
                    form.value['axCategory'] = initQueryParams[key];
                }
                if (key === "type") {
                    currentType.value = initQueryParams[key];
                }
                form.value[key] = initQueryParams[key];
            }
        }
        (0, vue_3.watch)(() => mainCategorySelectedItem.value, (mainCategory) => {
            for (const key in form.value) {
                if (form.value.hasOwnProperty(key)) {
                    if (key === "axCategory") {
                        form.value.axCategory = [mainCategory];
                        continue;
                    }
                    if (key === "type") {
                        currentType.value =
                            (0, forms_1.calculateTypeFromAxCategory)(mainCategory);
                        form.value[key] = currentType.value;
                        continue;
                    }
                    form.value[key] = null;
                }
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFilter_vue_1.default, {
                "search-label": (0, vue_2.unref)(i18n_1.trans)('accessories_search', 'Accessory search', 'accessories_search'),
                form: (0, vue_2.unref)(form),
                "need-tag-search": false,
                category: currentType.value
            }, {
                filtersPrepend: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                        modelValue: mainCategorySelectedItem.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((mainCategorySelectedItem).value = $event)),
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('category', 'Category', 'search_form'),
                        items: mainCategoryItems.value,
                        "disable-deselect": ""
                    }, null, 8, ["modelValue", "placeholder", "items"])
                ]),
                defaultFilters: (0, vue_2.withCtx)(() => {
                    var _a;
                    return [
                        (mainCategorySelectedItem.value === '730')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownInput_vue_1.default, {
                                key: 0,
                                modelValue: (0, vue_2.unref)(form).diameter,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (((0, vue_2.unref)(form).diameter) = $event)),
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'tyre_filter'),
                                items: (_a = (0, vue_2.unref)(filterValues)) === null || _a === void 0 ? void 0 : _a.diameters.values
                            }, null, 8, ["modelValue", "placeholder", "items"]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1))
                    ];
                }),
                _: 1
            }, 8, ["search-label", "form", "category"]));
        };
    }
});
